const toString = Object.prototype.toString;

export function is(val: unknown, type: string) {
  return toString.call(val) === `[object ${type}]`;
}

export function isObject(val: any): val is Record<any, any> {
  return val !== null && is(val, 'Object');
}
export function isFunction(val: unknown): val is (...args: any[]) => any {
  return typeof val === 'function';
}

export function isString(val: unknown): val is string {
  return typeof val === 'string';
}

export function isNumber(val: unknown): val is number {
  return is(val, 'Number');
}
/**
 * 判断时间字符串是否为空
 * 后端返回的时间字段字符串 是0001-01-01T08:05:43+08:05代表也是空时间
 * @param value 时间字符串
 * @returns
 */
export function isTimeNull(value: string) {
  if (!value || value === '0001-01-01T08:05:43+08:05' || value?.includes?.('0001-01-01')) {
    return true;
  } else {
    return false;
  }
}
